import { defineMessages } from "react-intl";

export const giftCardEnableDisableSectionMessages = defineMessages({
  successfullyEnabledTitle: {
    id: "bDO9DN",
    defaultMessage: "Successfully enabled gift card",
    description: "success gift card enable message",
  },
  successfullyDisabledTitle: {
    id: "GibKGn",
    defaultMessage: "Successfully disabled gift card",
    description: "success gift card disable message",
  },
});

export const giftCardUpdatePageHeaderMessages = defineMessages({
  resendButtonLabel: {
    id: "lCPxtT",
    defaultMessage: "Resend code",
    description: "resend code label",
  },
  expiredStatusLabel: {
    id: "aPYFO1",
    defaultMessage: "Expired",
    description: "expired status label",
  },
  disabledStatusLabel: {
    id: "EA7rjI",
    defaultMessage: "Disabled",
    description: "disabled status label",
  },
});
